const SOUNDPROOFING_LAYER_TYPES = {
  glass: 'glass',
  frame: 'frame',
};

const SOUNDPROOFING_LAYER_SIZES = {
  [SOUNDPROOFING_LAYER_TYPES.glass]: { width: 45, height: 242 },
  [SOUNDPROOFING_LAYER_TYPES.frame]: { width: 60, height: 242 },
  addButton: { width: 80, height: 242 },
  // Applied to not selected layers while another layer is selected
  inactiveScale: 0.75,
};

// Glass - frame - glass - frame - glass
const SOUNDPROOFING_MAX_LAYERS_COUNT = 5;

const SOUNDPROOFING_GLASS_KINDS = {
  single: 'single',
  laminated: 'laminated',
};

const SOUNDPROOFING_PRODUCT_TYPES = {
  singleGlass: 'singleGlass',
  laminatedGlass: 'laminatedGlass',
  singleChamberUnit: 'singleChamberUnit',
  doubleChamberUnit: 'doubleChamberUnit',
};

const SOUNDPROOFING_RANGE_KEYS = {
  thickness: 'thickness',
  rw: 'rw',
  rwC: 'rwC',
  rwCtr: 'rwCtr',
};

// TODO: take the limits from the backend when the API is ready
const SOUNDPROOFING_RANGE_LIMITS = {
  [SOUNDPROOFING_RANGE_KEYS.thickness]: { min: 4, max: 60 },
  [SOUNDPROOFING_RANGE_KEYS.rw]: { min: 20, max: 70 },
  [SOUNDPROOFING_RANGE_KEYS.rwC]: { min: 4, max: 10 },
  [SOUNDPROOFING_RANGE_KEYS.rwCtr]: { min: 4, max: 100 },
};

// TODO: take the options from the backend when the API is ready
const SOUNDPROOFING_THICKNESS_OPTIONS = {
  [SOUNDPROOFING_GLASS_KINDS.single]: ['3', '4', '5', '6', '8', '10', '12'],
  [SOUNDPROOFING_GLASS_KINDS.laminated]: ['33.1', '33.2', '44.1', '44.2', '55.1', '55.2', '66.1', '66.2'],
  [SOUNDPROOFING_LAYER_TYPES.frame]: ['6', '8', '10', '12', '14', '16', '18', '20', '24'],
  // Total thickness of the configuration in the results filters
  results: ['17', '24', '28', '32', '36', '40', '44'],
};

const SOUNDPROOFING_PAGE_SIZES = [20, 50, 100];

const SOUNDPROOFING_MAX_PDF_CONFIGURATIONS = 20;

export {
  SOUNDPROOFING_LAYER_TYPES,
  SOUNDPROOFING_LAYER_SIZES,
  SOUNDPROOFING_MAX_LAYERS_COUNT,
  SOUNDPROOFING_GLASS_KINDS,
  SOUNDPROOFING_PRODUCT_TYPES,
  SOUNDPROOFING_RANGE_KEYS,
  SOUNDPROOFING_RANGE_LIMITS,
  SOUNDPROOFING_THICKNESS_OPTIONS,
  SOUNDPROOFING_PAGE_SIZES,
  SOUNDPROOFING_MAX_PDF_CONFIGURATIONS,
};
